export class OAuthToken {
	refreshToken: string;
	accessToken: string;
	expiresIn: number;
	tokenType: string;

	constructor() {
		this.refreshToken = '';
		this.accessToken = '';
		this.expiresIn = 0;
		this.tokenType = '';
	}
}
